// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"77ff124d","198":"d5381457","453":"4f966eba"}[chunkId] + ".chunk.js";
};